import type { ChakraProps } from "@chakra-ui/react";
import type { ReactNode } from "react";
import { ChakraBox as Box } from "@airhelp/react-ui-components";

const UlList = ({ children, styles }: { children: ReactNode; styles: ChakraProps["sx"] }) => (
  <Box as="ul" sx={styles}>
    {children}
  </Box>
);

export default UlList;
